export enum AppErrorMajor {
  CarlNotAvailable = 'carlNotAvailable',
  LoadMotorization = 'loadMotorization',
  ResolveBaumuster = 'resolveBaumuster',
  ResolveOnlineCode = 'resolveOnlineCode'
}
